export enum DbMutation {
    Put = 'put',
    BulkPut = 'bulkPut',
    Remove = 'remove',
    BulkRemove = 'bulkRemove',
    Set = 'set'
}